import api from "../../../api";

const GLOBAL_CACHE_TTL_MS = 24 * 60 * 60 * 1000;
let globalRequest = null;
let globalAllRequest = null;

export default {
  setSelectedProject({ commit }, projectId) {
    commit("SET_SELECTED_PROJECT", projectId);
  },
  async getGlobal({ commit, state }, options = {}) {
    const cacheIsFresh = state.Global && Object.keys(state.Global).length > 0 &&
      Date.now() - state.globalLoadedAt < GLOBAL_CACHE_TTL_MS;
    if (!options.force && cacheIsFresh) return state.Global;
    if (globalRequest) return globalRequest;

    globalRequest = (async () => {
      commit("REQUEST_GLOBAL");
      if (!options.silent) commit("SET_LOADING", true, { root: true });
      try {
        const result = await api.getGlobal({});
        commit("SUCCESS_REQUEST_GLOBAL", result);
        commit("SET_GLOBAL_LOADED_AT", Date.now());
        return result.body;
      } catch (err) {
        if (!err.ok && err.status === 401) {
          commit("TO_LOGIN", true, { root: true });
        }
        commit("FAILURE_REQUEST_GLOBAL");
        return null;
      } finally {
        if (!options.silent) commit("SET_LOADING", false, { root: true });
      }
    })();

    try {
      return await globalRequest;
    } finally {
      globalRequest = null;
    }
  },
  async getGlobalAll({ commit, state }, options = {}) {
    const cacheIsFresh = state.status === "success" && Array.isArray(state.GlobalAll) &&
      Date.now() - state.globalAllLoadedAt < GLOBAL_CACHE_TTL_MS;
    if (!options.force && cacheIsFresh) return state.GlobalAll;
    if (globalAllRequest) return globalAllRequest;

    globalAllRequest = (async () => {
      commit("REQUEST_GLOBAL_ALL");
      if (!options.silent) commit("SET_LOADING", true, { root: true });
      try {
        const result = await api.getGlobalAll({});
        commit("SUCCESS_REQUEST_GLOBAL_ALL", result);
        commit("SET_GLOBAL_ALL_LOADED_AT", Date.now());
        return result.body;
      } catch (err) {
        if (!err.ok && err.status === 401) {
          commit("TO_LOGIN", true, { root: true });
        }
        commit("FAILURE_REQUEST_GLOBAL_ALL");
        return null;
      } finally {
        if (!options.silent) commit("SET_LOADING", false, { root: true });
      }
    })();

    try {
      return await globalAllRequest;
    } finally {
      globalAllRequest = null;
    }
  },
  async updateGlobal({ commit }, item ) {
    commit("REQUEST_UPDATE_GLOBAL");
    commit("SET_LOADING", true, { root: true });
    try {
      const result = await api.updateGlobal(item);
      commit("SUCCESS_REQUEST_UPDATE_GLOBAL", result);
      commit("UPSERT_GLOBAL_ALL", result.body);
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_UPDATE_GLOBAL");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async createGlobal({ commit }, item ) {
    commit("REQUEST_CREATE_GLOBAL");
    commit("SET_LOADING", true, { root: true });
    try {
      const result = await api.createGlobal(item);
      commit("SUCCESS_REQUEST_CREATE_GLOBAL", result);
      commit("UPSERT_GLOBAL_ALL", result.body);
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_CREATE_GLOBAL");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }
};
